import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { Refill } from "../../../models/refill";
import { DateHandlerService } from "../../../commons/date-handler.service";
import { RefillsHandlerService } from "../../../api-handlers/refills-handler.service";
import { AuthService } from "../../../auth-n-routing/auth-service.service";
import { RefPaginatorComponent } from "./paginator/ref-paginator.component";
import { User } from "../../../models/user";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ExportXLSPDF } from "../../../commons/export-xls-pdf.service";

@Component({
  selector: "app-refills",
  templateUrl: "./refills.component.html",
  styleUrls: ["./refills.component.css"],
})
export class RefillsComponent implements OnInit {
  refills_list: Refill[];
  modalRef: BsModalRef;
  @Output() statusChanged = new EventEmitter();
  @ViewChild(RefPaginatorComponent, { static: false })
  paginator: RefPaginatorComponent;

  picModal: any = {
    title: "",
    pic1: "",
    pic2: "",
  };

  dom_elements = {
    small_screen: false,
  };

  isInProgress = false;

  reloadList() {
    this.isInProgress = true;
    this.refillsHandlerService.reloadRefillsListAndCount().then((res) => {
      this. refills_list = this.refillsHandlerService.refills_list;
      this.isInProgress = false;
      this.changeDetector.detectChanges();
    });
  }

  constructor(
    public authService: AuthService,
    private changeDetector: ChangeDetectorRef,
    public dateHandler: DateHandlerService,
    private modalService: BsModalService,
    private refillsHandlerService: RefillsHandlerService,
    public exportService: ExportXLSPDF
  ) {
    this.dom_elements.small_screen = window.screen.width < 470;
  }

  ngOnInit() {
    this.authService.authChange.subscribe((u: User) => {
      if (u) {
        this.reloadList();
      }
    });
  }

  approveRefill(refill: Refill) {
    const r = confirm("Sicuro di voler approvare il rifornimento?");
    if (r === true) {
      this.refillsHandlerService
        .approveRefill(refill)
        .then((refillNew: Refill) => {
          refill.status.id = refillNew.status.id;
          refill.status.name = refillNew.status.name;
          this.statusChanged.next(undefined);
          this.reloadList();
        });
    }
  }

  declineRefill(refill: Refill) {
    const r = confirm("Sicuro di voler rifiutare il rifornimento?");
    if (r === true) {
      this.refillsHandlerService
        .declineRefill(refill)
        .then((refillNew: Refill) => {
          refill.status.id = refillNew.status.id;
          refill.status.name = refillNew.status.name;
          this.statusChanged.next(undefined);
          this.reloadList();
        });
    }
  }

  restoreRefill(refill: Refill) {
    const r = confirm("Riportare il rifornimento in stato di attesa conferma?");
    if (r === true) {
      this.refillsHandlerService
        .restoreRefill(refill)
        .then((refillNew: Refill) => {
          refill.status.id = refillNew.status.id;
          refill.status.name = refillNew.status.name;
          this.statusChanged.next(undefined);
          this.reloadList();
        });
    }
  }

  refillAdded() {
    this.paginator.refreshCurrentPage();
  }

  openFotoDialog(refill: Refill, template: TemplateRef<any>) {
    this.picModal.title =
      refill.travel.user.surname +
      " - " +
      refill.travel.vehicle.plate +
      " : " +
      this.dateHandler.formatDateClassic(refill.made_at) +
      ":" +
      this.dateHandler.formatTimeClassic(refill.made_at);

    this.refillsHandlerService
      .getImage(refill.recive_pic_onlinepath)
      .then((res) => {
        this.picModal.pic1 = res;
      });

    this.refillsHandlerService
      .getImage(refill.box_pic_onlinepath)
      .then((res) => {
        this.picModal.pic2 = res;
      });
    this.modalRef = this.modalService.show(template);
  }
}
